import React, {useState} from 'react';
import './App.css';
import View from './view';
import Question from './question';

function App() {
  const [question, setQuestion]= useState(Question);
  
  return (
    <main>
    <div className="App">
      <header className="App-header">
       <h1>Questions And Answers About Login</h1>
       
      </header>
      <section className="container">
         {
           question.map((quest)=>{
             return <View key={quest.id} {...quest} />
           })
         }
       </section>
       
    </div>
    <p className="text">- By MOHAMMED NAJJAR</p>
    </main>
  );
}

export default App;
